export const EMAIL_SENDER_MODAL_HEADER = 'Send email';
export const EMAIL_SENDER_MODAL_SUB_HEADER = 'To send an email to all consumers in the list, select the appropriate email connector and email template';
export const EMAIL_SENDER_MODAL_ACTION_TEXT = 'Send email';
export const EMAIL_SENDER_MODAL_CANCEL_TEXT = 'Cancel';
export const EMAIL_SENDER_MODAL_LABEL = 'Bulk email sender';
export const EMAIL_SENDER_MODAL_DESCRIBED_BY = 'Sending Bulk emails to affected customers by a certain rule';

export const EMAIL_SENDER_MODAL_FORM_CONNECTOR = 'Email connector';
export const EMAIL_SENDER_MODAL_FORM_TEMPLATE = 'Email template';
export const EMAIL_SENDER_ERROR_CONNECTOR = 'You must select an email connector';
export const EMAIL_SENDER_ERROR_TEMPLATE = 'You must select an email template';

export const CONFIRMATION_MODAL_HEADER = 'Send email?';
export const CONFIRMATION_MODAL_SUB_HEADER = 'Sending this email will result in an email being sent to all consumers whose shipments are currently in this list.';
export const CONFIRMATION_MODAL_ACTION_TEXT = 'Yes, send email';
export const CONFIRMATION_MODAL_CANCEL_TEXT = 'No, don\'t send email';
export const CONFIRMATION_MODAL_LABEL = 'Bulk email confirmation';
export const CONFIRMATION_MODAL_DESCRIBED_BY = 'To confirm if you are happy to send bulk emails';

export const BULK_CUSTOM_EVENT_TYPE_BUTTON_LABEL = 'Trigger custom event';
export const BULK_CUSTOM_EVENT_TYPE_MODAL_HEADER = 'Select custom event';
export const BULK_CUSTOM_EVENT_TYPE_SUB_HEADER = 'This will send a custom event to all shipments in this list.';
export const BULK_CUSTOM_EVENT_TYPE_MODAL_ACTION_TEXT = 'Trigger custom event';
export const BULK_CUSTOM_EVENT_TYPE_MODAL_CANCEL_TEXT = 'Cancel';
export const BULK_CUSTOM_EVENT_TYPE_MODAL_LABEL = 'Bulk action confirmation';
export const BULK_CUSTOM_EVENT_TYPE_MODAL_DESCRIBED_BY = 'To confirm if you are happy to trigger a bulk action';
export const BULK_CUSTOM_EVENT_TYPE_ERROR = 'You must select a custom event';

export const CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_HEADER = 'Trigger custom event?';
export const CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_SUB_HEADER = 'The chosen custom event will trigger for all selected shipments. Are you sure?';
export const CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_ACTION_TEXT = 'Yes, trigger custom event';
export const CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_CANCEL_TEXT = 'No, cancel';
export const CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_LABEL = 'Custom event trigger confirmation';
export const CUSTOM_EVENT_TYPE_CONFIRMATION_MODAL_DESCRIBED_BY = 'To confirm if you are happy to trigger the custom event';
